import Api from '../api';

class PinConfiguationService {

  getPinConfiguration = async () => {
    return await Api.get('/pin-config');
  }
   
}

export default new PinConfiguationService();
